import { Lock } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@livcg/nodecg-react";
import { Button } from "../ui/index.js";

export function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(username, password);
      // The socket connected without a cookie before login — unless we reload, the
      // server does not know whose commands they are in the operator log.
      window.location.reload();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid place-items-center h-full p-6">
      <form
        onSubmit={submit}
        className="w-full max-w-sm space-y-4 rounded-xl border border-border bg-surface-muted/60 p-6 shadow-[0_1px_0_0_var(--p-hi)_inset]"
      >
        <div className="flex items-center gap-2 text-ink">
          <Lock className="h-4 w-4" />
          <h2 className="t-heading">Tizimga kirish</h2>
        </div>
        <div className="space-y-2">
          <label className="block">
            <span className="block t-mono mb-1.5">Foydalanuvchi</span>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
              className="h-9 w-full rounded-md border border-border bg-surface px-3 text-[14px] text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-strong/60"
            />
          </label>
          <label className="block">
            <span className="block t-mono mb-1.5">Parol</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              className="h-9 w-full rounded-md border border-border bg-surface px-3 text-[14px] text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-strong/60"
            />
          </label>
        </div>
        {error && (
          <p className="rounded-md border border-danger/30 bg-danger/10 px-3 py-2 text-[13px] text-danger-strong">
            {error}
          </p>
        )}
        <Button type="submit" variant="primary" size="lg" className="w-full" disabled={busy}>
          Kirish
        </Button>
      </form>
    </div>
  );
}
